/** The ticket list, its filters, and the new-ticket dialog. */
const en = {
  title: 'Tickets',
  count: (n: number) => `${n} tickets`,
  configuration: 'Configuration',
  newTicket: 'New Ticket',
  searchPlaceholder: 'Search tickets, sessions…',
  filters: {
    all: 'All Tickets',
    hasReplay: 'Has Replay',
    hasRage: 'Rage Clicks',
    hasError: 'JS Errors',
    highFrustration: 'High Frustration',
  },
  chips: {
    replay: 'Replay',
    ai: 'AI',
  },
  unassigned: 'Unassigned',
  emptyFiltered: 'No tickets match this filter.',
  empty: 'No tickets yet. Create your first one.',
  /** Status and priority names the API returns in upper case. */
  status: {
    OPEN: 'Open',
    IN_PROGRESS: 'In progress',
    WAITING: 'Waiting',
    RESOLVED: 'Resolved',
    CLOSED: 'Closed',
  } as Record<string, string>,
  priority: {
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    CRITICAL: 'Critical',
  } as Record<string, string>,
  dialog: {
    title: 'New ticket',
    ticketTitle: 'Title',
    description: 'Description',
    priority: 'Priority',
    customerName: 'Customer name',
    customerEmail: 'Customer email',
    linkSession: 'Link a session (optional)',
    project: 'Project',
    none: 'None',
    sessionId: 'Session ID',
    sessionPlaceholder: 'session uuid',
    failed: 'Couldn’t create the ticket.',
    creating: 'Creating…',
    create: 'Create ticket',
  },
  detail: {
    notFound: 'Ticket not found.',
    priority: 'Priority',
    status: 'Status',
    createBug: 'Create Bug from Session',
    noDescription: 'No description.',
    screenshot: 'Annotated screenshot',
    screenshotAlt: 'Annotated tester screenshot',
    signals: 'Session Signals',
    duration: 'Duration',
    rageClicks: 'Rage Clicks',
    deadClicks: 'Dead Clicks',
    jsErrors: 'JS Errors',
    frustrationScore: 'Frustration Score',
    watchReplay: 'Watch replay',
    notes: 'Internal Notes',
    noNotes: 'No notes yet.',
    notePlaceholder: 'Add an internal note…',
    addNote: 'Add',
    details: 'Details',
    customer: 'Customer',
    email: 'Email',
    company: 'Company',
    assignee: 'Assignee',
    unassigned: 'Unassigned',
    created: 'Created',
    updated: 'Updated',
    tags: 'Tags',
    noTags: 'No tags.',
    addTag: 'Add tag',
    linkedSession: 'Linked Session',
    deleteTitle: (n: number) => `Delete ticket TK-${n}?`,
    deleteBody: 'This permanently removes the ticket and its notes. This can’t be undone.',
  },
};

const tr: typeof en = {
  title: 'Talepler',
  count: (n: number) => `${n} talep`,
  configuration: 'Yapılandırma',
  newTicket: 'Yeni talep',
  searchPlaceholder: 'Talep, oturum ara…',
  filters: {
    all: 'Tüm talepler',
    hasReplay: 'Kaydı olan',
    hasRage: 'Öfke tıklaması',
    hasError: 'JS hataları',
    highFrustration: 'Yüksek zorlanma',
  },
  chips: {
    replay: 'Kayıt',
    ai: 'AI',
  },
  unassigned: 'Atanmamış',
  emptyFiltered: 'Bu filtreye uyan talep yok.',
  empty: 'Henüz talep yok, ilkini oluşturun.',
  status: {
    OPEN: 'Açık',
    IN_PROGRESS: 'Devam ediyor',
    WAITING: 'Bekliyor',
    RESOLVED: 'Çözüldü',
    CLOSED: 'Kapandı',
  },
  priority: {
    LOW: 'Düşük',
    MEDIUM: 'Orta',
    HIGH: 'Yüksek',
    CRITICAL: 'Kritik',
  },
  dialog: {
    title: 'Yeni talep',
    ticketTitle: 'Başlık',
    description: 'Açıklama',
    priority: 'Öncelik',
    customerName: 'Müşteri adı',
    customerEmail: 'Müşteri e-postası',
    linkSession: 'Bir oturum bağla (isteğe bağlı)',
    project: 'Proje',
    none: 'Yok',
    sessionId: 'Oturum kimliği',
    sessionPlaceholder: 'oturum uuid',
    failed: 'Talep oluşturulamadı.',
    creating: 'Oluşturuluyor…',
    create: 'Talep oluştur',
  },
  detail: {
    notFound: 'Talep bulunamadı.',
    priority: 'Öncelik',
    status: 'Durum',
    createBug: 'Oturumdan hata kaydı aç',
    noDescription: 'Açıklama yok.',
    screenshot: 'İşaretlenmiş ekran görüntüsü',
    screenshotAlt: 'İşaretlenmiş test ekran görüntüsü',
    signals: 'Oturum sinyalleri',
    duration: 'Süre',
    rageClicks: 'Öfke tıklamaları',
    deadClicks: 'Ölü tıklamalar',
    jsErrors: 'JS hataları',
    frustrationScore: 'Zorlanma puanı',
    watchReplay: 'Kaydı izle',
    notes: 'İç notlar',
    noNotes: 'Henüz not yok.',
    notePlaceholder: 'Bir iç not ekleyin…',
    addNote: 'Ekle',
    details: 'Ayrıntılar',
    customer: 'Müşteri',
    email: 'E-posta',
    company: 'Şirket',
    assignee: 'Atanan',
    unassigned: 'Atanmamış',
    created: 'Oluşturulma',
    updated: 'Güncellenme',
    tags: 'Etiketler',
    noTags: 'Etiket yok.',
    addTag: 'Etiket ekle',
    linkedSession: 'Bağlı oturum',
    deleteTitle: (n: number) => `TK-${n} talebi silinsin mi?`,
    deleteBody: 'Bu işlem talebi ve notlarını kalıcı olarak siler. Geri alınamaz.',
  },
};

export const tickets = { en, tr };
